import { ArrowRight, Info, ShoppingBag, Trash2, X } from "lucide-react";
import type { CartItem, CustomerDetails, OrderValidationErrors } from "../types";
import { CustomerDetailsFields } from "./CustomerDetailsFields";
import { OrderValidationSummary } from "./OrderValidationSummary";

type CartPanelProps = {
  cart: CartItem[];
  customer: CustomerDetails;
  isOpen: boolean;
  isSubmitting: boolean;
  validationErrors: OrderValidationErrors;
  onClose: () => void;
  onCustomerChange: (customer: CustomerDetails) => void;
  onRemove: (id: string) => void;
  onSubmit: () => void;
};

export function CartPanel({
  cart,
  customer,
  isOpen,
  isSubmitting,
  validationErrors,
  onClose,
  onCustomerChange,
  onRemove,
  onSubmit,
}: CartPanelProps) {
  return (
    <aside className={`cart-panel${isOpen ? " cart-panel--open" : ""}`} aria-label="Din beställning">
      <div className="cart-panel__header">
        <div>
          <span className="eyebrow eyebrow--light">Din order</span>
          <h2>Beställning</h2>
        </div>
        <button className="icon-button cart-panel__close" type="button" onClick={onClose} aria-label="Stäng beställningen">
          <X size={22} />
        </button>
      </div>

      <div className="cart-panel__content">
        <div className="order-explainer">
          <Info size={18} aria-hidden="true" />
          <p>
            Priserna är ungefärliga och anges som barn/vuxen där två priser visas. Beställning kan ske när minst 5 stycken per plagg har beställts.
          </p>
        </div>

        <div className="cart-list-heading">
          <h3>Valda plagg</h3>
          <span>{cart.length} st</span>
        </div>

        {cart.length === 0 ? (
          <div className={`cart-empty${validationErrors.cart ? " cart-empty--invalid" : ""}`}>
            <ShoppingBag size={27} aria-hidden="true" />
            <p>Din beställning är tom.</p>
            <span>Välj storlek och lägg till ett plagg.</span>
          </div>
        ) : (
          <ul className="cart-list">
            {cart.map((item) => (
              <li key={item.id}>
                <div>
                  <strong>{item.garmentName}</strong>
                  <span>Storlek {item.size}</span>
                </div>
                <button type="button" onClick={() => onRemove(item.id)} aria-label={`Ta bort ${item.garmentName}`}>
                  <Trash2 size={17} />
                </button>
              </li>
            ))}
          </ul>
        )}

        <CustomerDetailsFields customer={customer} errors={validationErrors} onChange={onCustomerChange} />
      </div>

      <div className="cart-panel__footer">
        <OrderValidationSummary errors={validationErrors} />
        <button className="primary-button primary-button--light" type="button" onClick={onSubmit} disabled={isSubmitting}>
          {isSubmitting ? "Skickar…" : "Lägg beställning"}
          {!isSubmitting && <ArrowRight size={19} aria-hidden="true" />}
        </button>
        <p>Frågor? Kontakta Sanna Skoog eller Ylva Olm.</p>
      </div>
    </aside>
  );
}
